import { BrushElement } from './brush/brush-element.js';
import { BrushElementDefaultProps } from './brush/consts.js';
import { ConnectorElement } from './connector/connector-element.js';
import { ConnectorElementDefaultProps } from './connector/consts.js';
import {} from './connector/types.js';
import { GroupElementDefaultProps } from './group/consts.js';
import { GroupElement } from './group/group-element.js';
import { ShapeElementDefaultProps } from './shape/consts.js';
import { ShapeElement } from './shape/shape-element.js';
import { TextElementDefaultProps } from './text/consts.js';
import { TextElement } from './text/text-element.js';
// eslint-disable-next-line simple-import-sort/exports
export { BrushElement } from './brush/brush-element.js';
export { ConnectorElement } from './connector/connector-element.js';
export { ShapeElement } from './shape/shape-element.js';
export { TextElement } from './text/text-element.js';
export { GroupElement } from './group/group-element.js';
export { ConnectorMode } from './connector/types.js';
export { SHAPE_TEXT_PADDING } from './shape/consts.js';
export { normalizeShapeBound } from './shape/utils.js';
export { getFontString, getLineHeight, getLineWidth, normalizeTextBound, } from './text/utils.js';
export const ElementCtors = {
    brush: BrushElement,
    shape: ShapeElement,
    connector: ConnectorElement,
    text: TextElement,
    group: GroupElement,
};
export const ElementDefaultProps = {
    brush: BrushElementDefaultProps,
    shape: ShapeElementDefaultProps,
    connector: ConnectorElementDefaultProps,
    text: TextElementDefaultProps,
    group: GroupElementDefaultProps,
};
//# sourceMappingURL=index.js.map